export default "__VITE_ASSET__D5974bVO__"